var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 235,
    viewBox: "0 0 322 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M63.3576 234.834L7.50229 178.979C2.66394 174.141 0 167.708 0 160.866C0 154.023 2.66451 147.59 7.50229 142.752L142.417 7.83773C152.406 -2.14903 168.655 -2.14903 178.644 7.83773L313.579 142.752C318.417 147.591 321.083 154.023 321.083 160.866C321.083 167.709 318.417 174.141 313.579 178.979L277.728 214.83L274.83 211.931L310.68 176.08C314.744 172.016 316.984 166.613 316.984 160.865C316.984 155.117 314.744 149.715 310.68 145.65L175.745 10.7352C167.354 2.34589 153.704 2.34589 145.316 10.7352L10.4009 145.65C6.33743 149.713 4.09975 155.117 4.09975 160.865C4.09975 166.613 6.33743 172.017 10.4009 176.08L66.2562 231.936L63.3576 234.834Z",
    fill: "url(#paint0_linear_1457_2985)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1457_2985",
    x1: 74.2884,
    y1: 132.924,
    x2: 318.776,
    y2: 132.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.b8b45054bd26ed32c276425af23b44b7.svg";
export { ForwardRef as ReactComponent };